import { FAQ } from 'sections/Resources/BillOfLading/types';

export const faqItems: FAQ[] = [
  {
    id: '0',
    question: 'What is the difference between a Straight Bill of Lading and an Order Bill of Lading?',
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          A Straight Bill of Lading is non-negotiable and consigned to a specific recipient, while an Order Bill of Lading is negotiable and can be transferred to a third party through endorsements. The Straight BoL is used for direct deliveries, while the Order BoL allows for the transfer of ownership during transit.
        </p>
      `
    ),
  },
  {
    id: '1',
    question: 'How can I track my shipment using the Bill of Lading?',
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          You can use tools like CARGOES Flow to track your shipment in real-time using the BoL number. This tool provides visibility into the location and status of your cargo, helping you monitor its progress and anticipate any issues that may arise.
        </p>
      `
    ),
  },
  {
    id: '2',
    question: 'What are the consequences of errors in a Bill of Lading?',
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Errors in a Bill of Lading can lead to delays, additional costs, and legal disputes. Incorrect information on the BoL can result in customs delays, fines, and potential litigation. It is crucial to ensure that BoLs are accurate and comply with all legal requirements.
        </p>
      `
    ),
  },
  {
    id: '3',
    question: 'What is a Sea Waybill, and when should it be used?',
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          A Sea Waybill is a transport document that does not serve as a document of title and does not need to be presented to claim the goods. It is used for shipments where no transfer of ownership is involved, simplifying the logistics process and reducing paperwork.
        </p>
      `
    ),
  },
  {
    id: '4',
    question: 'How can I ensure compliance with international regulations for Bills of Lading?',
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Stay up-to-date with the latest regulations and ensure that your Bills of Lading comply with all relevant laws of the countries of origin and the final destination ports. Use digital tools to digitize the documentation process and ensure that all information is accurate and compliant.
        </p>
      `
    ),
  },
  {
    id: '5',
    question: 'Can a Bill of Lading be amended after it has been issued?',
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          Yes, a Bill of Lading can be amended, but the process can be complex and may require approval from all parties involved. Amendments should be made carefully to avoid legal and logistical issues.
        </p>
      `
    ),
  },
  {
    id: '6',
    question: 'How can I use a Bill of Lading to secure financing for my shipment?',
    answer: (cn: Function) => (
      `
        <p class='${cn('faq__answer-paragraph')}'>
          An Order Bill of Lading can be used as a document of title to secure financing for your shipment. The BoL can be endorsed and transferred to a third party, such as a bank, which can provide financing based on the value of the goods. For additional resources, reach out to your personalised account manager or contact us.
        </p>
      `
    ),
  },
];
